export const pages = {
    start: {
        id: 'start',
    },
    templates: {
        id: 'templates',
    },
    kite: {
        id: 'kite',
    },
    parts: {
        id: 'kite',
    },
    importExport: {
        id: 'importExport',
    },
};

export default pages;
